import { render, staticRenderFns } from "./slider-boxer-product.vue?vue&type=template&id=82167c9e&scoped=true&"
import script from "./slider-boxer-product.vue?vue&type=script&lang=js&"
export * from "./slider-boxer-product.vue?vue&type=script&lang=js&"
import style0 from "./slider-boxer-product.vue?vue&type=style&index=0&id=82167c9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82167c9e",
  null
  
)

export default component.exports